import { useTranslation } from "react-i18next";
import { Button } from "../../../components/ui/button/index.js";
import {
  AlertDialog,
  AlertDialogActions,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogTitle,
} from "../../../components/ui/alert-dialog/index.js";

export function WhatsAppCancelPendingDialog({
  open,
  onOpenChange,
  busy,
  onConfirm,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  busy: boolean;
  onConfirm: () => void;
}): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogTitle>{t("whatsapp.cancelPendingConfirm.title")}</AlertDialogTitle>
        <AlertDialogDescription>
          {t("whatsapp.cancelPendingConfirm.description")}
        </AlertDialogDescription>
        <AlertDialogActions>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={busy}>
            {t("whatsapp.cancelPendingConfirm.cancel")}
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={busy}>
            {t("whatsapp.cancelPendingConfirm.confirm")}
          </Button>
        </AlertDialogActions>
      </AlertDialogContent>
    </AlertDialog>
  );
}
